/**
 * @group Constants
 * @summary
 * <blockquote>Constants for learning progress status values</blockquote>
 * 
 * @example
 * ```typescript
 * import { LEARNING_PROGRESS_STATUSES } from '@shared/constants';
 * 
 * if (progress.status === LEARNING_PROGRESS_STATUSES.NOT_STARTED) {
 *   // Handle not started status
 * }
 * ```
 */
export const LEARNING_PROGRESS_STATUSES = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed'
} as const; 